import search from './search.vue'

search.install = function(Vue) {
  Vue.component(search.name, search)
}

export default search
